import React, { useEffect, useState } from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
// import Snackbar from '@material-ui/core/Snackbar';
// import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
// import InfoIcon from '@material-ui/icons/Info';
// import WarningIcon from '@material-ui/icons/Warning';
// import { amber, green } from '@material-ui/core/colors';
// import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, Grid } from '@material-ui/core';
import { Info } from '@material-ui/icons';



// const variantIcon = {
//   success: CheckCircleIcon,
//   warning: WarningIcon,
//   error: ErrorIcon,
//   info: InfoIcon,
// };
// const useStyles1 = makeStyles(theme => ({
//   success: {
//     backgroundColor: green[600],
//   },
//   error: {
//     backgroundColor: theme.palette.error.dark,
//   },
//   info: {
//     backgroundColor: theme.palette.primary.main,
//   },
//   warning: {
//     backgroundColor: amber[700],
//   },
//   icon: {
//     fontSize: 20,
//   },
//   iconVariant: {
//     opacity: 0.9,
//     marginRight: theme.spacing(1),
//   },
//   message: {
//     display: 'flex',
//     alignItems: 'center',
//   },
// }));

/* const useStyles2 = makeStyles(theme => ({
  margin: {
    margin: theme.spacing(1),
  },
})); */

// const MySnackbarContentWrapper = (props) => {
//   const classes = useStyles1();
//   // const classes = snackStyles(props);
//   const { className, message, onClose, variant, ...other } = props;
//   const Icon = variantIcon[variant];

//   return (
//     <SnackbarContent
//       className={clsx(classes[variant], className)}
//       aria-describedby="client-snackbar"
//       message={
//         <span id="client-snackbar" className={classes.message}>
//           <Icon className={clsx(classes.icon, classes.iconVariant)} />
//           {message}
//         </span>
//       }
//       action={[
//         <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
//           <CloseIcon className={classes.icon} />
//         </IconButton>,
//       ]}
//       {...other}
//     />
//   );
// }
const SnackBars = ({ oncloseSnack, openSnackbar, message, type }) => {
  // const classes = useStyles2();
  const [icon, setIcon] = useState(<Info />)

  const getIcon = () => {
    switch (type) {
      case 'error':
        setIcon(<ErrorIcon style={{ color: 'red', fontSize: '48px' }} />)
        break
      case 'success':
        setIcon(<CheckCircleIcon style={{ color: 'green', fontSize: '48px' }} />)
        break;

      default:
        break;
    }
  }

  useEffect(() => {
    getIcon()
    // eslint-disable-next-line
  }, [type])

  return (
    <>
      {/* <Snackbar
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
            }}
            open={openSnackbar}
            autoHideDuration={6000}
            onClose={oncloseSnack}
        >
            <MySnackbarContentWrapper
            onClose={oncloseSnack}
            variant={ type }
            message= { message }
            />
        </Snackbar> */}
      <Dialog
        open={openSnackbar}
        onClose={oncloseSnack}
        maxWidth={'sm'}
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 16,
          }
        }}
        BackdropProps={{
          style: {
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
          }
        }}
      >
        <DialogContent>
          <Grid style={{ textAlign: 'right' }}>
            <IconButton style={{ padding: 0 }} onClick={oncloseSnack}>
              <CloseIcon />
            </IconButton>
          </Grid>
          <Grid style={{ textAlign: 'center' }}>
            <b>{icon}</b>
            <p><b>Estimado usuario,</b></p>
            <p>{message}</p>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

SnackBars.propTypes = {
  // classes: PropTypes.object.isRequired,
  openSnackbar: PropTypes.bool.isRequired,
  oncloseSnack: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default (SnackBars);